module.exports = __webpack_public_path__ + "static/media/direct_icon.80fcb6ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/direct_icon.png
// module id = 13798
// module chunks = 0